import React from "react";

function PoweredBy() {
  return (
    <div
      style={{
        position: 'absolute',
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: "rgba(255,255,255,0.7)",
        marginTop: 32,
        bottom: 50,
      }}
    >
      <span>Powered by</span>
      <img
        src="https://prowly-uploads.s3.eu-west-1.amazonaws.com/uploads/1036/assets/56130/Spotify_Logo_CMYK_Green.png"
        alt="spotify logo"
        style={{ width: 100, objectFit: "contain" }}
      />
    </div>
  );
}

export default PoweredBy;